import { FC } from 'react';
import { PageTitle, PageLink } from '../../../rbts/layout/core';
import { View } from './components/View';

const TicketsPage: FC = () => {
  const widgetsBreadCrumbs: Array<PageLink> = [];

  return (
    <>
      <PageTitle breadcrumbs={widgetsBreadCrumbs}>Generación de Tickets</PageTitle>
      <View />
    </>
  );
};

export { TicketsPage };
export default TicketsPage;
